import store from '@/store'
import { getCustomerGroup } from '@/api/qc/model'
import globalVaribale from '@/utils/globalVariable'
export default {
  /**
   * 获取应用菜单
   * @param {应用根菜单的路由path} moduleRootPath
   */
  qcGetModuleMenu(moduleRootPath) {
    const allModuleMenu = store.state.user.authRoutes.filter(item => item.path === moduleRootPath)
    if (allModuleMenu && allModuleMenu.length !== 0) {
      return allModuleMenu[0].children
    }
    return []
  },
  /**
   * 获取模块按钮权限
   * @param {模块名称} module
   * @param {权限组path} buttonGroupPath
   */
  qcHasButtonAuth(module, id) {
    const affAppId = window.$envUtils('VUE_APP_QC_SERVICE').substring(1, window.$envUtils('VUE_APP_QC_SERVICE').length)
    const moduleAuth = store.state.user.appAuthDetail[affAppId]
    const temp = qcRecuHasAuth(moduleAuth, id)
    return !!temp
  },
  /**
   * 获取模块按钮权限
   * @param {模块名称} module
   * @param {权限组path} buttonGroupPath
   */
  qcHasListAuth(module, id) {
    const affAppId = window.$envUtils('VUE_APP_QC_SERVICE').substring(1, window.$envUtils('VUE_APP_QC_SERVICE').length)
    const moduleAuth = store.state.user.appAuthDetail[affAppId]
    return qcListHasAuth(moduleAuth, id)
  },
  /** 输出用户权限筛选后的技能组 */
  qcSkillGroupList(tree, id, functions) {
    // 先获取权限
    const power = this.qcHasListAuth(tree, id)
    getCustomerGroup().then(response => {
      if (power.option === 'ALL') {
        functions(response)
      } else if (power.option === 'ckssjnz') {
        const dataList = response.data.data
        const array = []
        for (let i = 0; i < dataList.length; i++) {
          const skillUsers = dataList[i].skillUsers
          if (skillUsers) {
            for (let j = 0; j < skillUsers.length; j++) {
              if (store.state.user.loginUser.userId === skillUsers[j].id && skillUsers[j].skillGroupId !== globalVaribale.defaultSkillGroupId) {
                array.push(dataList[i])
                break
              }
            }
          }
        }
        response.data.data = array
        functions(response)
      } else if (power.option === 'jkckzj') {
        const dataList = response.data.data
        const array = []
        for (let i = 0; i < dataList.length; i++) {
          const skillUsers = dataList[i].skillUsers
          if (skillUsers) {
            const my = []
            for (let j = 0; j < skillUsers.length; j++) {
              if (store.state.user.loginUser.userId === skillUsers[j].id) {
                my.push(skillUsers[j])
                dataList[i].skillUsers = my
                array.push(dataList[i])
                break
              }
            }
          }
        }
        response.data.data = array
        functions(response)
      } else if (power.option === 'zdykz') {
        const dataList = response.data.data
        const array = []
        for (let i = 0; i < dataList.length; i++) {
          for (let j = 0; j < power.detail.jnzData.length; j++) {
            const jnz = power.detail.jnzData[j]
            if (jnz.id === dataList[i].id) {
              array.push(dataList[i])
              break
            }
          }
        }
        response.data.data = array
        functions(response)
      }
    })
  }
}
/**
 * 循环查找满足条件的按钮
 * @param {*} tree
 * @param {*} path
 */
const qcRecuHasAuth = (tree, id) => {
  var stark = []
  stark = stark.concat(tree)
  while (stark.length) {
    var temp = stark.shift()
    if (temp && temp.children) {
      stark = temp.children.concat(stark)
    }
    if (temp && id === temp.id && temp.displayType === '0' && temp.value !== 'false') {
      return temp
    }
  }
}

/**
 * 循环查找满足条件的数据
 * @param {*} tree
 * @param {*} path
 */
const qcListHasAuth = (tree, id) => {
  var stark = []
  stark = stark.concat(tree)
  while (stark.length) {
    var temp = stark.shift()
    if (temp && temp.children) {
      stark = temp.children.concat(stark)
    }
    if (temp && id === temp.id && temp.displayType === '2' && temp.value) {
      return temp.value
    }
  }
}
